import { render, staticRenderFns } from "./feedbackInfo.vue?vue&type=template&id=f88c80cc"
import script from "./feedbackInfo.vue?vue&type=script&lang=js"
export * from "./feedbackInfo.vue?vue&type=script&lang=js"
import style0 from "./feedbackInfo.vue?vue&type=style&index=0&id=f88c80cc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports